const widgetFilter = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon points="9.35 11.05 6.65 13 6.65 8.6 2.5 3 13.5 3 9.35 8.6"/></svg>',
};

export { widgetFilter as default };
